import { render, staticRenderFns } from "./add-user-page.vue?vue&type=template&id=b8c701e6&scoped=true&"
import script from "./add-user-page.vue?vue&type=script&lang=js&"
export * from "./add-user-page.vue?vue&type=script&lang=js&"
import style0 from "./add-user-page.vue?vue&type=style&index=0&id=b8c701e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c701e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VTextField})
